import React from 'react';
import { motion } from 'framer-motion';
import { FiAlertCircle } from 'react-icons/fi';

const TaxSeasonClosedBanner = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="relative -mt-20 z-20 mb-8"
    >
      <div className="container mx-auto px-4">
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 rounded-xl shadow-2xl p-6 border-2 border-amber-600">
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <FiAlertCircle className="text-white text-3xl flex-shrink-0" />
            <p className="text-white text-lg md:text-xl font-semibold text-center">
              Closed to new clients for the 2025 tax season. Returning clients may still schedule.
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default TaxSeasonClosedBanner;